// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER



//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$('.msdw-page-scroll').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = 0;
      if ( window.innerWidth <= 767 ) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 59;
        // console.log(offsetValue);
      }

      $('html,body').animate({
        scrollTop: target.offset().top - offsetValue
      }, 900);
      return false;
    }
  }
});


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

// const scroll = window.requestAnimationFrame;

// function showOnScroll() {
//   const elems = document.querySelectorAll('.msdw-animate');

//   elems.forEach((el) => {
//     const elPosition = el.getBoundingClientRect().top
//     const elScreen = window.innerHeight / .9

//     if (elPosition < elScreen) {
//       el.classList.add('msdw-animated')
//     }
//   });

//   scroll(showOnScroll);
// }

// showOnScroll();


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

// var swiper = new Swiper('.swiper-container', {
//   slidesPerView: 1,
//   loop: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
// });


//
// =SLIDER (SLICK JS)
// --------------------------------------------------

// Main Slider

$('#msdw-main-slider').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: true,
  fade: true,
  dots: false,
  arrows: true,
  prevArrow: '<svg class="msdw-prev" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 2.5L7.5 15L20 27.5L22.5 25L12.5 15L22.5 5L20 2.5Z" fill="#222"/></svg>',
  nextArrow: '<svg class="msdw-next" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 27.5L22.5 15L10 2.5L7.5 5L17.5 15L7.5 25L10 27.5Z" fill="#222"/></svg>'
});

$('.slick-prev').click(function() {
  $('#msdw-main-slider').slick('slickPrev');
});

$('.slick-next').click(function() {
  $('#msdw-main-slider').slick('slickNext');
});


// hardcoded go-to "dots"

$('[data-slide]').click(function() {
  var slideNumber = $(this).data('slide');
  $('#msdw-main-slider').slick('slickGoTo', slideNumber - 1);
});


// Mini slider in sync

$('.msdw-data-slider').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  swipe: false,
  fade: true,
  arrows: false
});

$('.msdw-data-slider-nav').slick({
  infinite: false,
  slidesToShow: 7,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  focusOnSelect: true,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 449, // >= 450
      settings: {
        slidesToShow: 9,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
});

// Reinit mini slider

$('#msdw-main-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
  $(slick.$slides.get(currentSlide)).find('.msdw-data-slider').slick('refresh');
  $(slick.$slides.get(currentSlide)).find('.msdw-data-slider-nav').slick('refresh');

  $(slick.$slides.get(currentSlide)).find('.msdw-data-slider').slick('slickGoTo', 0);
});

// UNSLICK
// If needed, here's a fix for window resizing
// $(window).on('orientationchange resize', function() {
//   $('.msdw-top-slider').slick('resize');
// });


//
// =PRODUCT PICKER
// --------------------------------------------------

// $(".product-detail-picker").click(function(e){
//   e.preventDefault();
//   var productIdNumber = $(this).attr('data-product-id');
//   window.jwsdwMediator.publish('openPicker', 'productDetailPicker', {'productId': productIdNumber});
// });


//
// =NEWSLETTER PICKER
// --------------------------------------------------

// var campaignId = 'familyAndFriends',
//     pickerTag = document.getElementById("openPicker"),
//     newsletterConfig = {},
//     baseUrl = jwsdwSettings.baseUrl;

// $.ajax({
//   type: 'GET',
//   url: baseUrl + '/Newsletter-getNewsletterConfig',
//   data: {
//     campaignId: campaignId
//   },
//   success: function(response) {
//     newsletterConfig = response
//   },
//   error: function(response) {
//     jwsdwApi.popup.showHttpError(response.status)
//   }
// });

// pickerTag.addEventListener("click", function(){
//   window.jwsdwMediator.publish('openPicker', 'newsletterSignupPicker', {
//     "campaign": newsletterConfig.id,
//     "introduction": newsletterConfig.introduction,
//     "disclaimerOne": newsletterConfig.disclaimerOne,
//     "disclaimerTwo": newsletterConfig.disclaimerTwo
//   });
// });
